import React from "react"
import { Link, graphql } from "gatsby"
import { Link as ScrollLink } from "react-scroll"
import { StaticImage } from "gatsby-plugin-image"

import Layout from "../../components/layout"
import PostContentHeader from "../../components/post-content-header"
import PostMainImage from "../../components/post-main-image"
import CategoryDateShare from "../../components/category-date-share"
import Seo from "../../components/seo"

import _ from 'lodash'
import ogImage from "../../images/posts/70/thumb-landscape.jpg"

const Post70 = ({ data: { allCategoryJson, postsJson }, location }) => {

  const category = _.find(allCategoryJson.edges, (edge) => {
    return edge.node.categoryId === postsJson.categoryId
  }).node

return (
<Layout>
  <Seo title={postsJson.title} description={postsJson.description} ogImage={ogImage} />
  <div className="posts">
    <PostContentHeader categoryName={category.nameJA} postTitle={postsJson.title} location={location} />
    <section id="pickup-article">
      <PostMainImage post={postsJson} />
      <div className="description wrapper text-two-cloumn">
        <CategoryDateShare category={category} post={postsJson} />
        <div className="title">
          <h1>{postsJson.title}</h1>
          <p>「エルメスって憧れるけど、どのバッグから選べばいいの？」<br></br>
          「バーキンやケリーは有名だけど、いきなりはハードルが高い…」</p>
          <p>そんな疑問を持っていませんか？</p>
          <p>この記事では、エルメス初心者が“<b className="text-font-bolder">最初の一歩</b>”として選びやすい定番バッグや選び方のポイントを、分かりやすく解説します。さらに、「購入」と「レンタル」という選択肢も含めて、後悔しない始め方をご紹介します。</p>
        </div>
      </div>
    </section>
    <div className="wrapper">
    <section className="bag-content">
      <div className="text-two-cloumn">
        <h2 style={{color: "#0a9186"}}>目次</h2>
        <p>
          <div style={{margin: "1rem 0"}}>
            <ScrollLink className="scroll" to="sec1" smooth={true} duration={500} offset={-80} style={{fontSize: "2rem"}}><span style={{color: "#0a9186"}}>1 |</span>&nbsp;&nbsp;エルメス初心者がまず知っておくべきこと｜なぜ選び方が難しいのか</ScrollLink>
          </div>
          <div style={{margin: "1rem 0"}}>
            <ScrollLink className="scroll" to="sec2" smooth={true} duration={500} offset={-80} style={{fontSize: "2rem"}}><span style={{color: "#0a9186"}}>2 |</span>&nbsp;&nbsp;初心者におすすめのエルメス定番モデル</ScrollLink><br></br>
            <ScrollLink className="scroll text-indent" to="sec3" smooth={true} duration={500} offset={-80}>❖&nbsp;&nbsp;ピコタンロック｜まずはここから。王道の入門モデル</ScrollLink><br></br>
            <ScrollLink className="scroll text-indent" to="sec4" smooth={true} duration={500} offset={-80}>❖&nbsp;&nbsp;エヴリン｜動きやすさ重視なら最適な一つ</ScrollLink><br></br>
            <ScrollLink className="scroll text-indent" to="sec5" smooth={true} duration={500} offset={-80}>❖&nbsp;&nbsp;ガーデンパーティ｜通勤にも使える万能トート</ScrollLink>
          </div>
          <div style={{margin: "1rem 0"}}>
            <ScrollLink className="scroll" to="sec6" smooth={true} duration={500} offset={-80} style={{fontSize: "2rem"}}><span style={{color: "#0a9186"}}>3 |</span>&nbsp;&nbsp;失敗しない選び方のポイント</ScrollLink>
          </div>
          <div style={{margin: "1rem 0"}}>
            <ScrollLink className="scroll" to="sec7" smooth={true} duration={500} offset={-80} style={{fontSize: "2rem"}}><span style={{color: "#0a9186"}}>4 |</span>&nbsp;&nbsp;購入とレンタル、どちらが初心者向きか</ScrollLink><br></br>
            <ScrollLink className="scroll text-indent" to="sec8" smooth={true} duration={500} offset={-80}>❖&nbsp;&nbsp;実際にどうだった？年齢・利用歴別リアル体験</ScrollLink>
          </div>
          <div style={{margin: "1rem 0"}}>
            <ScrollLink className="scroll" to="sec9" smooth={true} duration={500} offset={-80} style={{fontSize: "2rem"}}><span style={{color: "#0a9186"}}>5 |</span>&nbsp;&nbsp;FAQ｜よくある質問</ScrollLink>
          </div>
        </p>
      </div>
      <section name="sec1" className="section-content">
        <figure>
          <StaticImage src="../../images/posts/70/1.jpg" alt=""/>
        </figure>
        <div className="mt8">
          <h2>エルメス初心者がまず知っておくべきこと｜なぜ選び方が難しいのか</h2>
        </div>
        <p>エルメス選びで迷わないために、最初に押さえておきたい考え方があります。</p>
        <p>まず知っておきたいのは、エルメスのバッグ選びが難しい理由です。モデルの種類は非常に豊富で、エルメスの代表格であるバーキンやケリー以外にも、多くの選択肢が存在します。さらに価格帯も数十万円から数百万円まで幅広く、人気モデルは正規店での入手が難しいケースも少なくありません。</p>
        <p>こうした「選択肢の多さ」と「一つひとつの判断の重さ」が重なることで、初心者にとってエルメス選びは難しく感じられます。</p>
        <p>だからこそ重要なのは、最初からバーキンやケリーにこだわりすぎないことです。確かに魅力的なモデルですが、価格や入手難易度を考えると、最初の一歩としては現実的ではない場合もあります。</p>
        <p>それよりも大切なのは、「どこで使うか」という視点です。日常使いなのか、通勤なのか、それとも特別な日なのか。使うシーンから逆算することで、自分に合うモデルが自然と見えてきます。</p>
        <p>そしてもうひとつ重要なのが、「試してから選ぶ」という考え方です。エルメスのバッグは見た目だけでは分からない要素が多く、実際に使ってみて初めてサイズ感や使い勝手、自分との相性が明確になります。</p>
        <p>最初の一歩は、「憧れ」ではなく「自分に合うかどうか」。この視点を持つことで、エルメス選びはぐっとシンプルになります。</p>
      </section>
      <section name="sec2" className="section-content">
        <figure>
          <StaticImage src="../../images/posts/70/2.jpg" alt=""/>
        </figure>
        <div className="mt8">
          <h2>初心者におすすめのエルメス定番モデル</h2>
        </div>
        <p>では、実際にどのモデルから始めるのが良いのでしょうか。<br></br>
        ここでは、初心者が最初の一つとして選びやすい代表モデルを、特徴とあわせてご紹介します。</p>
        <div name="sec3" className="mt4">
          <h3>◆ ピコタンロック｜まずはここから。王道の入門モデル</h3>
          <div className="img-three-cloumn">
            <figure className="img-small">
              <StaticImage src="../../images/posts/70/3.jpg" alt=""/>
            </figure>
            <figure className="img-small">
              <StaticImage src="../../images/posts/70/4.jpg" alt=""/>
            </figure>
            <figure className="img-small">
              <StaticImage src="../../images/posts/70/5.jpg" alt=""/>
            </figure>
          </div>
          <p>エルメスの中でも、最初の一つとして選ばれることが多いのがピコタンロックです。<br></br>
          コロンとしたフォルムとシンプルなデザインが特徴で、カジュアルにもきれいめにも自然に馴染みます。見た目以上に使い勝手がよく、エルメスらしい上質さも感じられるため、「何から始めるか迷ったらこれ」と言える定番モデルです。</p>
        </div>
        <div name="sec4" className="mt4">
          <h3>◆ エヴリン｜動きやすさ重視なら最適な一つ</h3>
          <div className="img-three-cloumn">
            <figure className="img-small">
              <StaticImage src="../../images/posts/70/6.jpg" alt=""/>
            </figure>
            <figure className="img-small">
              <StaticImage src="../../images/posts/70/7.jpg" alt=""/>
            </figure>
            <figure className="img-small">
              <StaticImage src="../../images/posts/70/8.jpg" alt=""/>
            </figure>
          </div>
          <p>ショルダータイプで両手が空くエヴリンは、外出や旅行、アクティブに動く日に活躍するモデルです。気軽に使えるデザインで、日常に取り入れやすいのが魅力。ラクに持てる分、長時間のお出かけでもストレスを感じにくいのが特徴です。</p>
        </div>
        <div name="sec5" className="mt4">
          <h3>◆ ガーデンパーティ｜通勤にも使える万能トート</h3>
          <div className="img-three-cloumn">
            <figure className="img-small">
              <StaticImage src="../../images/posts/70/9.jpg" alt=""/>
            </figure>
            <figure className="img-small">
              <StaticImage src="../../images/posts/70/10.jpg" alt=""/>
            </figure>
            <figure className="img-small">
              <StaticImage src="../../images/posts/70/11.jpg" alt=""/>
            </figure>
          </div>
          <p>シンプルなトート型のガーデンパーティは、A4サイズも収納できる実用性の高さが魅力です。きちんと感がありながら、堅すぎないデザインで、仕事から普段使いまで幅広く対応できます。荷物が多い方や、オン・オフ兼用したい方におすすめです。</p>
        </div>
        <p className="mt4">バーキンやケリーは多くの人にとって憧れの存在ですが、最初から目指すよりも、まずは他モデルでサイズ感や使い勝手を理解してから検討する方が、結果的に満足度が高くなる傾向があります。</p>
      </section>
      <section name="sec6" className="section-content">
        <figure>
          <StaticImage src="../../images/posts/70/12.jpg" alt=""/>
        </figure>
        <div className="mt8">
          <h2>失敗しない選び方のポイント</h2>
        </div>
        <p>エルメス選びで後悔しないためには、いくつかの視点を持っておくことが大切です。</p>
        <p>まず意識したいのは、使うシーンです。普段使いであればピコタンやエヴリン、仕事であればガーデンパーティといったように、用途から考えることで選択肢が整理されます。</p>
        <p>次に重要なのがサイズ感です。同じモデルでもサイズが違うだけで使い勝手は大きく変わります。スマートフォンや財布、ポーチなど日常的に持ち歩くものが無理なく収まるかどうかを基準に考えることが大切です。</p>
        <p>カラーについては、最初はブラックやエトゥープ、ゴールドといったベーシックカラーを選ぶことで、コーディネートしやすく長く使うことができます。</p>
        <p>素材選びも見逃せません。柔らかく扱いやすいもの、型崩れしにくいものなど、それぞれに特徴があります。初心者は扱いやすさを重視すると安心です。</p>
        <p>そして最後に重要なのが、「実際に使ってみること」です。重さやフィット感、コーディネートとの相性は、実際の生活の中でしか判断できません。</p>
      </section>
      <section name="sec7" className="section-content">
        <figure>
          <StaticImage src="../../images/posts/70/13.jpg" alt=""/>
        </figure>
        <div className="mt4">
          <h2>購入とレンタル、どちらが初心者向きか</h2>
        </div>
        <p>エルメスを始める際に悩むのが、購入するかレンタルするかという点です。</p>
        <p>購入は、所有できる安心感や資産性がある一方で、初期費用が大きく、もし自分に合わなかった場合のリスクも高くなります。特に初心者の場合、「思っていたのと違った」というズレが起こりやすいのが現実です。</p>
        <p>一方でレンタルは、実際に使いながら比較できるという大きなメリットがあります。複数のモデルやサイズ、カラーを試しながら、自分に合うものを見極めることができます。</p>
        <p>ラクサスでは60ブランド・数万点以上のバッグを取り扱っており、エルメスの複数モデルを比較しながら利用できる環境が整っています。往復送料無料やキズ補償といった仕組みもあり、高額バッグでも日常の中で安心して試せるのが特徴です。</p>
        <p>実際の利用傾向としては、まずピコタンやエヴリンなどの使いやすいモデルをレンタルし、その後サイズや使い勝手を理解した上で購入を検討する、という流れが多く見られます。</p>
        <p>では、実際にレンタルから始めた人は、どのように感じているのでしょうか。</p>
        <div name="sec8" className="mt4">
          <h3>◆ 実際にどうだった？年齢・利用歴別リアル体験</h3>
          <h4 className="mt4"><span className="text-border-bottom">（ラクサスユーザー歴3ヶ月｜30代後半・子育て中）</span></h4>
          <div className="text-img-cloumn-main">
            <figure className="img-xs">
              <StaticImage src="../../images/posts/70/14.jpg" alt=""/>
            </figure>
            <div>
              <p>「最初にピコタンロックを選びました。見た目が可愛くて“これがいい”と直感で決めたんですが、実際に使ってみると長財布やポーチを入れたときに思ったより余裕がなくて、少し窮屈に感じました。</p>
              <p>写真で見ていたときはちょうどいいサイズに見えていたので、この差は意外でしたね。その後ワンサイズ上を試してみて、ようやく“自分に合うサイズ感”が分かった感じです。</p>
              <p>もし最初から購入していたら、たぶん使わなくなっていたと思います。試せたからこそ納得できました。」</p>
            </div>
          </div>
          <h4 className="mt4"><span className="text-border-bottom">（ラクサスユーザー歴6ヶ月｜40代前半）</span></h4>
          <div className="text-img-cloumn-main">
            <figure className="img-xs">
              <StaticImage src="../../images/posts/70/15.jpg" alt=""/>
            </figure>
            <div>
              <p>「エヴリンを使ってみて、バッグの選び方が変わりました。正直、最初は少しカジュアルかなと思っていたんですが、実際に使ってみるととにかく楽です。</p>
              <p>ショルダーで両手が空くので、移動や外出がすごく快適になりました。特に長時間の外出では“もうこれ以外持てない”と思うくらいです。</p>
              <p>ただ、レストランや少しきちんとした場面ではラフに感じることもあって、“シーンによって最適なバッグは違う”というのを実感しました。」</p>
            </div>
          </div>
          <h4 className="mt4"><span className="text-border-bottom">（ラクサスユーザー歴1年｜30代前半）</span></h4>
          <div className="text-img-cloumn-main">
            <figure className="img-xs">
              <StaticImage src="../../images/posts/70/16.jpg" alt=""/>
            </figure>
            <div>
              <p>「通勤用としてガーデンパーティを使ってみました。収納力がしっかりあって、仕事用としては理想的だと思ったんですが、実際に使い続けると重さが気になるようになりました。</p>
              <p>荷物を入れると想像以上に重くなって、毎日使うには少し負担だなと感じてしまって。</p>
              <p>見た目やスペックだけでは分からない部分ってあるんだなと実感しましたし、“買う前に分かってよかった”と思えた経験でした。」</p>
            </div>
          </div>
        </div>
      </section>
      <section name="sec9" className="section-content">
        <figure>
          <StaticImage src="../../images/posts/70/17.jpg" alt=""/>
        </figure>
        <div className="mt8">
          <h2>FAQ｜よくある質問</h2>
        </div>
        <p>エルメスのバッグ選びでよくある疑問をまとめました。<br></br>
        結論として大切なのは、「どれが人気か」ではなく「自分に合うかどうか」です。</p>
        <p>見た目の印象と実際の使いやすさは必ずしも一致せず、サイズや重さ、使うシーンとの相性は、日常の中で初めて明確になります。</p>
        <p>だからこそ、いきなり購入するのではなく、まずは試してみることが失敗しないポイントです。<br></br>
        迷ったら、「試してから選ぶ」。それがエルメスで後悔しない最短ルートです。</p>
        <dl className="faq-item mt4">
          <dt>Q. 初めてのエルメスで一番おすすめは？</dt>
          <dd>
            <p>A. ピコタンロックが最もバランスが良く、初心者に選ばれています。</p>
            <p>使いやすさ・価格帯・取り入れやすさの点で優れています。</p>
          </dd>
        </dl>
        <dl className="faq-item mt4">
          <dt>Q. バーキンやケリーは最初から狙ってもいい？</dt>
          <dd>
            <p>A. 可能ですが、価格や入手難易度が高いため、まずは他モデルでサイズ感や使い勝手を理解してから検討する方が失敗しにくいです。</p>
          </dd>
        </dl>
        <dl className="faq-item mt4">
          <dt>Q. レンタルでも品質は大丈夫？</dt>
          <dd>
            <p>A. ラクサスではプロによる鑑定体制が整っており、品質管理も徹底されています。</p>
            <p>通常使用によるキズや汚れは補償対象のため、安心して利用できます。</p>
          </dd>
        </dl>
        <dl className="faq-item mt4">
          <dt>Q. レンタルと購入、最終的にはどちらがいい？</dt>
          <dd>
            <p>A. 初心者の場合は「レンタルで試す → 気に入ったら購入」という流れが最も失敗が少ない選び方です。</p>
          </dd>
        </dl>
        <dl className="faq-item mt4">
          <dt>Q. どのくらい試せば判断できますか？</dt>
          <dd>
            <p>A. 1〜2ヶ月ほど使うことで、サイズ感や使い勝手、自分の生活との相性が明確に分かってきます。</p>
            <p>複数モデルを比較するのがおすすめです。</p>
          </dd>
        </dl>
        <div className="border"></div>
        <figure style={{maxWidth: "300px"}}>
          <StaticImage src="../../images/posts/70/18.png" alt=""/>
        </figure>
        <p>「いつか欲しい」を、「まず試してみる」から始めませんか。<br></br>
        ラクサスなら、憧れのエルメスを、もっと気軽に、もっと自分らしく楽しめます。まずはアプリで、あなたに似合うバッグを見つけてみてください。</p>
        <Link to="https://laxus.co/app/pc/bags/hermes" className="view-all-button">ラクサス公式サイトでエルメスのバッグを見てみる</Link>
      </section>
    </section>
    </div>
  </div>
</Layout>
)}

export default Post70

export const pageQuery = graphql`
  query {
    postsJson(postId: {eq: 70}) {
      id
      title
      postId
      postedAt
      description
      categoryId
      authorId
      thumbnailSquare {
        src {
          childImageSharp {
            gatsbyImageData
          }
        }
      }
      thumbnailLandscape {
        src {
          childImageSharp {
            gatsbyImageData
          }
        }
      }
    }
    allCategoryJson(sort: {fields: sortOrder}) {
      edges {
        node {
          id
          categoryId
          slug
          nameJA
          nameEN
          description
        }
      }
    }
  }
`
